export default __webpack_public_path__ + "static/media/vote-active.9c824dea.png";